import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "edit-skill-container form-container"
};
const _hoisted_2 = {
  style: {
    "flex": "1"
  }
};
const _hoisted_3 = {
  style: {
    "min-width": "4.2rem",
    "margin-left": "1.0rem"
  }
};
const _hoisted_4 = {
  style: {
    "min-width": "4.2rem",
    "margin-left": "1.0rem"
  }
};
const _hoisted_5 = {
  key: 0,
  class: "operator-container"
};
const _hoisted_6 = {
  key: 1,
  class: "operator-container"
};
import { ref, onMounted, computed } from 'vue';
import { ElButton, ElCol, ElForm, ElInput, ElInputNumber, ElMessage, ElOption, ElRow, ElSelect } from 'element-plus';
import { request } from '@/manager/net_manager';
import store from '@/store';
export default {
  __name: 'SectsSkillEditCard',
  props: {
    skillId: {
      type: Number,
      default: () => {
        return null;
      },
      required: false
    }
  },
  emits: ['close', 'complete'],

  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emits = __emit;
    const degreeOptions = ['C', 'B', 'A', 'S', 'SS']; // refs

    const message = ref(null);
    const loading = ref(false);
    const skillForm = ref({
      id: null,
      sects: null,
      name: '',
      degree: 1,
      mysterious_level: 1,
      conventional: true,
      is_private: true,
      desc: '',
      deep_desc: '',
      cost: '',
      type: null,
      power_type: null,
      timing_type: null,
      cooldown: null,
      times: 0
    });
    const preSkill = ref(null);
    const preSkills = ref([]); // computed

    const worldOutlook = computed(() => store.state.world_outlook);
    const organizations = computed(() => {
      if (!worldOutlook.value) return null;
      return store.state.world_outlook_info[worldOutlook.value.id]?.organizations ?? null;
    });
    const cdTypes = computed(() => {
      if (!worldOutlook.value) return null;
      return store.state.world_outlook_info[worldOutlook.value.id]?.cd_types ?? null;
    });
    const skillTypes = computed(() => {
      if (!worldOutlook.value) return null;
      return store.state.world_outlook_info[worldOutlook.value.id]?.skill_types ?? null;
    });
    const timingTypes = computed(() => {
      if (!worldOutlook.value) return null;
      return store.state.world_outlook_info[worldOutlook.value.id]?.timing_types ?? null;
    });
    const powerTypes = computed(() => {
      if (!worldOutlook.value) return null;
      return store.state.world_outlook_info[worldOutlook.value.id]?.power_types ?? null;
    });
    const propsTypes = computed(() => {
      if (!worldOutlook.value) return null;
      return store.state.world_outlook_info[worldOutlook.value.id]?.props_types ?? null;
    });
    const propsTags = computed(() => {
      if (!worldOutlook.value) return null;
      return store.state.world_outlook_info[worldOutlook.value.id]?.props_tags ?? null;
    }); // functions

    const getData = () => {
      if (!worldOutlook.value) return;
      if (!organizations.value) store.dispatch('get_wo_organizations');
      if (!propsTypes.value) store.dispatch('get_props_types');
      if (!propsTags.value) store.dispatch('get_props_tags');

      if (!cdTypes.value) {
        request('world_outlook/get_cooldown_types/', {}, 'GET').then(response => {
          // console.log(JSON.stringify(response))
          if (response.code === 0) {
            store.commit('update_wo_info', {
              wo_id: worldOutlook.value.id,
              key: 'cd_types',
              value: response.data
            });
          }
        });
      }

      if (!powerTypes.value) {
        request('world_outlook/get_power_types/', {}, 'GET').then(response => {
          // console.log(JSON.stringify(response))
          if (response.code === 0) {
            store.commit('update_wo_info', {
              wo_id: worldOutlook.value.id,
              key: 'power_types',
              value: response.data
            });
          }
        });
      }

      if (!timingTypes.value) {
        request('world_outlook/get_timing_types/', {}, 'GET').then(response => {
          // console.log(JSON.stringify(response))
          if (response.code === 0) {
            store.commit('update_wo_info', {
              wo_id: worldOutlook.value.id,
              key: 'timing_types',
              value: response.data
            });
          }
        });
      }

      if (!skillTypes.value) {
        request('skills/config/get_skill_types/', {}, 'GET').then(response => {
          // console.log(JSON.stringify(response))
          if (response.code === 0) {
            store.commit('update_wo_info', {
              wo_id: worldOutlook.value.id,
              key: 'skill_types',
              value: response.data
            });
          }
        });
      }

      if (props.skillId) {
        const parameters = {
          'skill_id': props.skillId,
          'world_outlook_id': worldOutlook.value.id
        };
        request('skills/get/', parameters, 'POST').then(response => {
          // console.log(JSON.stringify(response))
          if (response.code === 0) {
            loadData(response.data);
          }
        });
      }
    };

    const loadData = skill => {
      skillForm.value = {
        id: skill.id,
        sects: skill.sects.id,
        name: skill.name,
        degree: degreeOptions.indexOf(skill.degree) + 1,
        mysterious_level: skill.mysterious_level,
        conventional: skill.conventional.toString().toUpperCase() === 'TRUE',
        is_private: skill.is_private.toString().toUpperCase() === 'TRUE',
        desc: skill.desc,
        deep_desc: skill.deep_desc,
        cost: skill.cost,
        type: skill.skill_type.id,
        power_type: skill.power_type.id,
        timing_type: skill.timing_type.id,
        cooldown: skill.cooldown.id,
        times: skill.times
      };

      if (skill.pre_skill) {
        preSkill.value = skill.pre_skill.id;
        preSkills.value = [skill.pre_skill];
      }
    };

    const getPreSkills = () => {
      if (skillForm.value.sects) {
        loading.value = true;
        request('skills/list/', {
          'organization_id': skillForm.value.sects,
          'is_precis': true
        }, 'POST').then(response => {
          // console.log(JSON.stringify(response))
          if (response.code === 0) {
            preSkills.value = response.data;
          }

          loading.value = false;
        });
      }
    };

    const createSkill = () => {
      if (message.value) {
        message.value.close();
      }

      let parameters = skillForm.value;
      parameters.world_outlook_id = worldOutlook.value.id;
      parameters.pre_skill_id = preSkill.value;
      request('skills/create/', parameters, 'POST').then(response => {
        if (response.code !== 0) {
          message.value = ElMessage.error({
            message: response.msg,
            duration: 1500
          });
          return;
        }

        message.value = ElMessage.success({
          message: '技能项已创建',
          duration: 1500
        });
        emits('complete');
        emits('close');
      });
    };

    const removeSkill = () => {
      if (message.value) {
        message.value.close();
      }

      request('skills/remove/', {
        'skill_id': props.skillId
      }, 'POST').then(response => {
        if (response.code !== 0) {
          message.value = ElMessage.error({
            message: response.msg,
            duration: 1500
          });
          return;
        }

        message.value = ElMessage.success({
          message: '技能项已清除',
          duration: 1500
        });
        emits('complete');
        emits('close');
      });
    };

    const updateSkill = () => {
      if (message.value) {
        message.value.close();
      }

      let parameters = {
        'updates': skillForm.value
      };

      if (preSkill.value) {
        parameters.updates.pre_skill = preSkill.value;
      } // console.log(parameters)


      request('skills/update/', parameters, 'POST').then(response => {
        if (response.code !== 0) {
          message.value = ElMessage.error({
            message: response.msg,
            duration: 1500
          });
          return;
        }

        message.value = ElMessage.success({
          message: '技能项已调整',
          duration: 1500
        });
        emits('complete');
        emits('close');
      });
    }; // lifecycle


    onMounted(() => {
      getData();
    });
    return (_ctx, _cache) => {
      const _component_el_form_item = _resolveComponent("el-form-item");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_unref(ElForm), {
        model: skillForm.value,
        "label-width": "auto"
      }, {
        default: _withCtx(() => [_createVNode(_unref(ElRow), {
          class: "form-row"
        }, {
          default: _withCtx(() => [_createVNode(_unref(ElCol), {
            span: 7
          }, {
            default: _withCtx(() => [_createVNode(_unref(ElRow), {
              style: {
                "align-items": "flex-end"
              }
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_form_item, {
                label: "从属流派",
                "label-position": "top"
              }, {
                default: _withCtx(() => [_createVNode(_unref(ElSelect), {
                  modelValue: skillForm.value.sects,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => skillForm.value.sects = $event),
                  placeholder: "流派",
                  "no-data-text": "无数据"
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(organizations.value, (item, index) => {
                    return _openBlock(), _createBlock(_unref(ElOption), {
                      key: index,
                      label: item['name'],
                      value: item['id']
                    }, null, 8, ["label", "value"]);
                  }), 128))]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              })]), _createElementVNode("div", _hoisted_3, [_createVNode(_unref(ElButton), {
                class: _normalizeClass(['change-button', skillForm.value.is_private ? 'active-change-button' : '']),
                onClick: _cache[1] || (_cache[1] = $event => skillForm.value.is_private = !skillForm.value.is_private)
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(skillForm.value.is_private ? '秘传' : '公开'), 1)]),
                _: 1
              }, 8, ["class"])]), _createElementVNode("div", _hoisted_4, [_createVNode(_unref(ElButton), {
                class: _normalizeClass(['change-button', skillForm.value.conventional ? 'active-change-button' : '']),
                onClick: _cache[2] || (_cache[2] = $event => skillForm.value.conventional = !skillForm.value.conventional)
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(skillForm.value.conventional ? '常规施法' : '构筑施法'), 1)]),
                _: 1
              }, 8, ["class"])])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_unref(ElCol), {
            offset: 1,
            span: 4
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "前置技能（非必须）",
              "label-position": "top"
            }, {
              default: _withCtx(() => [_createVNode(_unref(ElSelect), {
                modelValue: preSkill.value,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => preSkill.value = $event),
                placeholder: "前置技能",
                "no-data-text": "无数据",
                filterable: "",
                remote: "",
                clearable: "",
                "remote-method": getPreSkills,
                loading: loading.value
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(preSkills.value, (item, index) => {
                  return _openBlock(), _createBlock(_unref(ElOption), {
                    key: index,
                    label: item['name'],
                    value: item['id']
                  }, null, 8, ["label", "value"]);
                }), 128))]),
                _: 1
              }, 8, ["modelValue", "loading"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_unref(ElCol), {
            offset: 1,
            span: 11
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "技能名称",
              "label-position": "top"
            }, {
              default: _withCtx(() => [_createVNode(_unref(ElInput), {
                modelValue: skillForm.value.name,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => skillForm.value.name = $event),
                maxlength: "16",
                placeholder: "技能名称",
                round: "",
                type: "text",
                clearable: "",
                "show-word-limit": ""
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_unref(ElRow), {
          class: "form-row"
        }, {
          default: _withCtx(() => [_createVNode(_unref(ElCol), {
            span: 3
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "评定等级",
              "label-position": "top"
            }, {
              default: _withCtx(() => [_createVNode(_unref(ElSelect), {
                modelValue: skillForm.value.degree,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => skillForm.value.degree = $event),
                placeholder: "评定等级",
                "no-data-text": "无数据"
              }, {
                default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(degreeOptions, (item, index) => {
                  return _createVNode(_unref(ElOption), {
                    key: index,
                    label: `${item}级`,
                    value: index + 1
                  }, null, 8, ["label", "value"]);
                }), 64))]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_unref(ElCol), {
            offset: 1,
            span: 3
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "神秘等级",
              "label-position": "top"
            }, {
              default: _withCtx(() => [_createVNode(_unref(ElInputNumber), {
                modelValue: skillForm.value.mysterious_level,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => skillForm.value.mysterious_level = $event),
                min: 1,
                max: 12
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_unref(ElCol), {
            offset: 1,
            span: 3
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "限定使用次数",
              "label-position": "top"
            }, {
              default: _withCtx(() => [_createVNode(_unref(ElInputNumber), {
                modelValue: skillForm.value.times,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => skillForm.value.times = $event),
                min: 0,
                max: 10
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_unref(ElCol), {
            offset: 1,
            span: 5
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "技能消耗",
              "label-position": "top"
            }, {
              default: _withCtx(() => [_createVNode(_unref(ElInput), {
                modelValue: skillForm.value.cost,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => skillForm.value.cost = $event),
                type: "text",
                clearable: "",
                "show-word-limit": "",
                round: "",
                placeholder: "技能消耗",
                maxlength: "128"
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_unref(ElRow), {
          class: "form-row"
        }, {
          default: _withCtx(() => [_createVNode(_unref(ElCol), {
            span: 3
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "技能类型",
              "label-position": "top"
            }, {
              default: _withCtx(() => [_createVNode(_unref(ElSelect), {
                modelValue: skillForm.value.type,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => skillForm.value.type = $event),
                placeholder: "技能类型",
                "no-data-text": "无数据"
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(skillTypes.value, (item, index) => {
                  return _openBlock(), _createBlock(_unref(ElOption), {
                    key: index,
                    label: item['name'],
                    value: item['id']
                  }, null, 8, ["label", "value"]);
                }), 128))]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_unref(ElCol), {
            offset: 1,
            span: 3
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "力量源泉",
              "label-position": "top"
            }, {
              default: _withCtx(() => [_createVNode(_unref(ElSelect), {
                modelValue: skillForm.value.power_type,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => skillForm.value.power_type = $event),
                placeholder: "力量源泉",
                "no-data-text": "无数据"
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(powerTypes.value, (item, index) => {
                  return _openBlock(), _createBlock(_unref(ElOption), {
                    key: index,
                    label: item['name'],
                    value: item['id']
                  }, null, 8, ["label", "value"]);
                }), 128))]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_unref(ElCol), {
            offset: 1,
            span: 3
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "冷却回气",
              "label-position": "top"
            }, {
              default: _withCtx(() => [_createVNode(_unref(ElSelect), {
                modelValue: skillForm.value.cooldown,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => skillForm.value.cooldown = $event),
                placeholder: "冷却回气",
                "no-data-text": "无数据",
                clearable: ""
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cdTypes.value, (item, index) => {
                  return _openBlock(), _createBlock(_unref(ElOption), {
                    key: index,
                    label: item['desc'],
                    value: item['id']
                  }, null, 8, ["label", "value"]);
                }), 128))]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_unref(ElCol), {
            offset: 1,
            span: 3
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "发动时机",
              "label-position": "top"
            }, {
              default: _withCtx(() => [_createVNode(_unref(ElSelect), {
                modelValue: skillForm.value.timing_type,
                "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => skillForm.value.timing_type = $event),
                placeholder: "发动时机",
                "no-data-text": "无数据",
                clearable: ""
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(timingTypes.value, (item, index) => {
                  return _openBlock(), _createBlock(_unref(ElOption), {
                    key: index,
                    label: item['desc'],
                    value: item['id']
                  }, null, 8, ["label", "value"]);
                }), 128))]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_unref(ElRow), {
          class: "form-row"
        }, {
          default: _withCtx(() => [_createVNode(_unref(ElInput), {
            modelValue: skillForm.value.desc,
            "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => skillForm.value.desc = $event),
            type: "textarea",
            clearable: "",
            "show-word-limit": "",
            round: "",
            placeholder: "技能描述",
            maxlength: "256"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_unref(ElRow), {
          class: "form-row"
        }, {
          default: _withCtx(() => [_createVNode(_unref(ElInput), {
            modelValue: skillForm.value.deep_desc,
            "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => skillForm.value.deep_desc = $event),
            type: "textarea",
            clearable: "",
            "show-word-limit": "",
            round: "",
            placeholder: "深层描述",
            maxlength: "256"
          }, null, 8, ["modelValue"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["model"]), __props.skillId ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createVNode(_unref(ElButton), {
        class: "remove-skill",
        onClick: removeSkill
      }, {
        default: _withCtx(() => [...(_cache[15] || (_cache[15] = [_createTextVNode(" 移除技能 ", -1)]))]),
        _: 1
      }), _createVNode(_unref(ElButton), {
        onClick: updateSkill
      }, {
        default: _withCtx(() => [...(_cache[16] || (_cache[16] = [_createTextVNode(" 提交变更 ", -1)]))]),
        _: 1
      })])) : (_openBlock(), _createElementBlock("div", _hoisted_6, [_createVNode(_unref(ElButton), {
        onClick: createSkill
      }, {
        default: _withCtx(() => [...(_cache[17] || (_cache[17] = [_createTextVNode(" 创建技能 ", -1)]))]),
        _: 1
      })]))]);
    };
  }

};